module.exports = __webpack_public_path__ + "static/img/celoscope-detail-13.c70dc50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-13.jpg
// module id = 5MnA
// module chunks = 51